import { format, parseISO, isValid } from "date-fns";

export function formatDate(inputDate: string, showHour: boolean = false) {
  const isISODate = inputDate.endsWith("Z");

  if (!showHour) {
    const date = isISODate ? new Date(inputDate) : parseISO(inputDate);

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  } else {
    const date = isISODate ? new Date(inputDate) : parseISO(inputDate);

    // Check if the date is valid
    if (!isValid(date)) {
      return '';
    }

    // Format the date with hour and minute
    return format(date, "d MMMM HH:mm");
  }
}
